// Input.js
import React from 'react';

export const Input = ({ label, value, onChange, type = 'text', className = '', ...props }) => {
    return (
        <div className="flex flex-col gap-1 w-full">
            {label && (
                <label className="text-xs font-semibold text-neon-blue uppercase tracking-wider font-orbitron">
                    {label}
                </label>
            )}
            <input
                type={type}
                value={value}
                onChange={onChange}
                className={`
          flex h-9 w-full rounded-md border border-gray-700 bg-cyber-black px-3 py-1 text-sm shadow-sm transition-all 
          text-gray-100 font-rajdhani
          file:border-0 file:bg-transparent file:text-sm file:font-medium 
          placeholder:text-gray-500 
          focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-neon-blue focus-visible:border-neon-blue
          disabled:cursor-not-allowed disabled:opacity-50
          ${className}
        `}
                {...props}
            />
        </div>
    );
};
